import { Component, Input, OnInit } from '@angular/core';
import { FreudMessage } from '@freud-ds/web-components';
import { TranslateService } from '@ngx-translate/core';
import {
	ITEM_TYPE,
	SCOPE_TYPE,
	SUBSCOPE_TYPE,
} from 'app/interfaces/actiontracker.interface';
import { INewEvent } from 'app/interfaces/event.interface';
import { ActionTrackerService } from 'app/services/actiontracker.service';
import { AvailabilitiesService } from 'app/services/availabilities.service';
import { EventsService } from 'app/services/events.service';
import { DateTime } from 'luxon';
import { MessageService } from 'primeng/api';
import { timer } from 'rxjs';

@Component({
	selector: 'vc-schedule-alert',
	templateUrl: './vc-schedule-alert.component.html',
	styleUrls: ['./vc-schedule-alert.component.scss'],
})
export class VcScheduleAlertComponent implements OnInit {
	public showAlert = false;
	public dates = [];
	public isScheduling = false;
	@Input() appointment;
	state: 'loading' | 'success' | 'hasDates' | 'emptyDates' = 'hasDates';
	constructor(
		public availabilitiesService: AvailabilitiesService,
		private messageService: MessageService,
		public events: EventsService,
		public atService: ActionTrackerService,
		public translateService: TranslateService
	) {}

	ngOnInit(): void {
		const now = DateTime.local().toISO();
		const endDate = DateTime.fromFormat(this.appointment.endTime, 'HH:mm')
			.minus({ minutes: 25 })
			.toISO();
		let missingTime = DateTime.fromISO(endDate)
			.diff(DateTime.fromISO(now), ['seconds'])
			.toObject();
		if (missingTime.seconds < 0) {
			missingTime = { seconds: 0 };
		}
		timer(missingTime.seconds * 1000).subscribe(() => {
			this.availabilitiesService
				.getNextAvailableDate({ sessionId: this.appointment.id })
				.toPromise()
				.then((res: any) => {
					this.dates = res.nextAvailabilities || [];
					this.state = this.dates.length > 0 ? 'hasDates' : 'emptyDates';
					this.showAlert = !res.hasNextSession;
					if (this.showAlert) {
						this.atService.eventTracker(
							SCOPE_TYPE.VideoConference,
							SUBSCOPE_TYPE.Banner,
							this.dates.length > 0
								? ITEM_TYPE.HasResults
								: ITEM_TYPE.NoResults,
							null,
							{}
						);
					}
				});
		});
	}

	getFormatedDate(capitalizeFirstLetter = false) {
		if (this.dates.length) {
			let weekDay = DateTime.fromISO(this.dates[0].start).toFormat('cccc', {
				locale: 'pt-BR',
			});
			if (capitalizeFirstLetter) {
				weekDay = `${weekDay.charAt(0).toUpperCase() + weekDay.slice(1)}`;
			}
			return `${weekDay}, ${DateTime.fromISO(this.dates[0].start).toFormat(
				'dd/MM'
			)} às ${DateTime.fromISO(this.dates[0].start).toFormat('HH:mm')}`;
		}
	}

	close() {
		this.showAlert = false;
		this.atService.eventTracker(
			SCOPE_TYPE.VideoConference,
			SUBSCOPE_TYPE.Banner,
			ITEM_TYPE.BtnClose,
			null,
			{}
		);
	}

	async scheduleSession() {
		const appointment: INewEvent = {
			professionalId: this.appointment.professional.id,
			professionalOnline: false,
			price: this.appointment.price,
			startDate: this.dates[0].start,
			timezone: this.appointment.timezone,
			type: 'invite',
			userId: this.appointment.contact.id,
			contactId: this.appointment.contact.contactId,
			contactName: null,
			professionalAddressId: null,
		};
		this.isScheduling = true;
		this.events.saveNewEvent(appointment).subscribe(
			() => {
				this.state = 'success';
				this.isScheduling = false;
				this.atService.eventTracker(
					SCOPE_TYPE.VideoConference,
					SUBSCOPE_TYPE.Banner,
					ITEM_TYPE.BtnSchedule,
					null,
					{}
				);
			},
			({ error }) => {
				this.setError(error);
				this.isScheduling = false;
				this.atService.eventTracker(
					SCOPE_TYPE.VideoConference,
					SUBSCOPE_TYPE.Banner,
					ITEM_TYPE.Error,
					null,
					{}
				);
			}
		);
	}

	setError(error) {
		const message: FreudMessage = {
			severity: 'error',
			summary: error.messageI18n,
			detail: null,
		};
		this.messageService.add(message);
	}
}
